"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../helpers");
var style_1 = require("./style");
var CopyrightSection = function (_a) {
    var sentence = _a.sentence;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: helpers_1.nlToBr(sentence) } })));
};
exports.default = CopyrightSection;
